export const getActiveSegment = (pathname: string) =>
  pathname.split('/').filter(Boolean).slice(-1)[0]

export const getBaseUrlFromPathName = (pathname: string) => {
  const pathSegments = pathname.split('/').filter(Boolean)

  let baseUrl = ''
  if (pathSegments[0] === 'impersonate' && pathSegments.length >= 3) {
    // Matches: /impersonate/:environment/:businessId
    baseUrl = `/impersonate/${pathSegments[1]}/${pathSegments[2]}`
  } else if (pathSegments.length >= 1) {
    // Matches: /:demoName
    baseUrl = `/${pathSegments[0]}`
  }

  return baseUrl
}
